import React, { Suspense, lazy } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./App.min.css";
import OrderHistory from "./views/product/OrderHistory";
import PrivacyPolicy from "./components/quicklinks/PrivacyPolicy";
import TermsConditions from "./components/quicklinks/TermsConditions";
import ShippingPolicy from "./components/quicklinks/ShippingPolicy";
import CancellationRefund from "./components/quicklinks/CancellationRefund";
import NotFoundPage from "./views/NotFoundPage";
import OrderSuccess from "./views/OrderSuccess";
import SingleProduct from "./views/product/SingleProduct";
import ProductByCode from "./views/product/ProductByCode";
import BuyNow from "./views/product/BuyNow";

const Home = lazy(() => import("./components/home/Home"));

const SignInView = lazy(() => import("./components/account/SignInForm"));
const OtpVerification = lazy(() => import("./components/account/SignInOtp"));
const ProductListView = lazy(() => import("./views/product/List"));
const VendorRegisterForm = lazy(() =>
  import("./components/VendorRegistration")
);

const SaleInvoice = lazy(() =>
  import("./components/others/SaleInvoiceRedirect")
);
const Invoice1 = lazy(() => import("./components/invoices/Invoice1"));
const Invoice2 = lazy(() => import("./components/invoices/Invoice2"));
const Invoice3 = lazy(() => import("./components/invoices/Invoice3"));

const NotFoundView = lazy(() => import("./views/pages/404"));
const InternalServerErrorView = lazy(() => import("./views/pages/500"));

const PurchaseView = lazy(() => import("./views/purchaseOrder/PurchaseView"));
const CheckOutView = lazy(() => import("./views/product/Checkout"));
const Header = lazy(() => import("./views/Header"));
const ShopBrand = lazy(() => import("./views/product/ShopBrand"));
const OrderDetails = lazy(() => import("./views/product/OrderDetails"));

function App() {
  return (
    <BrowserRouter>
      <React.Fragment>
        {/* <TopMenu /> */}
        <Header />
        <Suspense
          fallback={
            <div className="text-white text-center mt-3">Loading...</div>
          }
        >
          <Routes>
            <Route exact path="/auth" element={<SignInView />} />
            <Route exact path="/otpverify" element={<OtpVerification />} />
            <Route exact path="/shop" element={<ProductListView />} />
            <Route exact path="/" element={<Home />} />
            <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route
              exact
              path="/terms-conditions"
              element={<TermsConditions />}
            />
            <Route exact path="/shipping-policy" element={<ShippingPolicy />} />
            <Route
              exact
              path="/cancellation-policy"
              element={<CancellationRefund />}
            />
            {/* /password/reset/:token */}
            <Route
              exact
              path={`/purchase-order/view`}
              element={<PurchaseView />}
            />
            <Route
              exact
              path={`/company/register`}
              element={<VendorRegisterForm />}
            />
            <Route
              exact
              path="/productdetails/:id"
              element={<SingleProduct />}
            />
            <Route
              exact
              path="/product-detail/:productCode"
              element={<ProductByCode />}
            />
            <Route exact path="/buy-now" element={<BuyNow />} />
            <Route exact path={`/saleInvoice/:id`} element={<SaleInvoice />} />
            <Route
              exact
              path={`/orderdetails/:id`}
              element={<OrderDetails />}
            />
            <Route exact path={`/W421u/:id`} element={<Invoice1 />} />
            <Route exact path={`/22O9q/:id`} element={<Invoice2 />} />
            <Route exact path={`/xI557/:id`} element={<Invoice3 />} />
            <Route exact path={`/shop/brand/:slug`} element={<ShopBrand />} />
            <Route exact path={`/orderhistory`} element={<OrderHistory />} />

            <Route exact path="/500" element={<InternalServerErrorView />} />
            <Route exact path="/checkout" element={<CheckOutView />} />
            <Route exact path="/ordersuccess" element={<OrderSuccess />} />

            {/* <Route path="*" element={<NotFoundView />} /> */}
            {/* <Route path="/" element={<Navigate to="/auth" />} /> */}
            <Route exact path="*" element={<NotFoundPage />} />
          </Routes>
        </Suspense>
      </React.Fragment>
    </BrowserRouter>
  );
}

export default App;
